import { Component, OnInit, OnDestroy } from '@angular/core';
import { MeetingsService } from '@app/services/meetings/meetings.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Meetings } from '@app/models/meetings';
import { Subscription, Observable, forkJoin } from 'rxjs';
import { Sort } from '@angular/material/sort';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { DatePipe, PlatformLocation } from '@angular/common';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { startWith, map } from 'rxjs/operators';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { SnackbarService } from '@app/services/shared/snackbar.service';
import { PermissionsService } from '@app/services/permissions/permissions.service';
import { MemberService } from '@app/services/member.service';
import { SortService } from '@app/components/sorting/SortService';
import { ConfirmationService } from 'primeng/api';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';

interface AttendanceData {
  meetingid: number;
  memberid: number;
  isguest: boolean;
  institutionid: number;
}

interface Attendant {
  attendanceId: number;
  memberId: number;
  givenName: string;
  familyName: string;
  checked: boolean;
  primaryInstitution: {
    shortName: string;
  }
}

interface LodgeAndCamp {
  id: number;
  shortName: string;
  name: string;
}

interface DeleteAttendant {
  attendanceId: number;
  memberId: number;
}

@Component({
  selector: 'app-meetingdetails',
  templateUrl: './meetingdetails.component.html',
  styleUrls: ['./meetingdetails.component.css']
})
export class MeetingdetailsComponent implements OnInit, OnDestroy {
  role;
  subscriptions: Subscription[] = [];
  viewmode = false;
  add = false;
  addguest = false;
  id: number;
  memberid: number;
  data: Meetings;
  attendants: Attendant[] = [];
  guestattendants: any[] = [];
  disable = false;
  edit = false;
  meetingdetaileditform;
  value: any;

  addattendancelist: number[] = [];
  deletelist: DeleteAttendant[] = [];
  deletedata: DeleteAttendant[] = [];
  attendantstoadd;
  attendancedata: any;

  myControl = new FormControl();
  institutions: LodgeAndCamp[] = [];
  filteredOptions: Observable<LodgeAndCamp[]>;
  selectedinstitution: any;
  selectedinstitutionname: string;
  selectedguestlist: any[] = [];
  addlist: any[] = [];

  minmaxyear = { minYear: '1920', maxYear: '2030' };
  autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy-mm-dd', this.minmaxyear);
  public mask = [/[1-9]/, /\d/, /\d/, ' ', /\d/, /\d/]; // zipcode
  public maskdatum = [/[129]/, /[?09]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
filteredInstitutions: LodgeAndCamp[] = []; // används i autocomplete
  institutionid: number;
  usualmember = false;

  // Behörigheter
  can_edit_attendance;
  // tslint:disable-next-line:max-line-length
  constructor(
    private meetingService: MeetingsService,
    private permissionsService: PermissionsService,
    private memberService: MemberService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private snackbarService: SnackbarService,
    private confirmationService: ConfirmationService,
    private router: Router,
    private location: PlatformLocation,
    private institutionsService: InstitutionsService,
    private snackBarService: SnackbarService,
  private datePipe: DatePipe) {
    location.onPopState(() => {
      this.edit = false;
    });

    if (this.route.snapshot.queryParams.viewmode) {
      this.viewmode = true;
    }
  }

  disableForm(dis) {
    this.disable = !dis;
    this.disable ? this.meetingdetaileditform.enable() : this.meetingdetaileditform.disable();
  }

  async ngOnInit() {
    this.meetingdetaileditform = this.fb.group({
      meetingDate: [null, null],
      issue: ['', Validators.maxLength(30)],
      comment: ['', ''],
      meetingTypeId: [null, null]
    });
    
    this.subscriptions.push(this.route.params.subscribe(params => {
      this.memberid = params['memberid'];
    }));
    // Hämta queryParams när man kommer från searchmeeting
    this.route.queryParams.subscribe(params => {

      this.add = false;
      this.attendantstoadd = null;
      this.id = params['id'];
      this.memberid = params['memberid'];
      this.usualmember = params['usualmember'];
      this.institutionid = params['institutionid'];
      this.setPermissions(this.institutionid);

      this.subscriptions.push(this.meetingService.getMeetingById(this.id).subscribe(meeting => {
        if (meeting) {
          this.meetingdetaileditform.disable();
          this.data = meeting;
          const formattedMeetingDate = this.datePipe.transform(this.data.meetingDate, 'yyyy-MM-dd') ?? '';
          
          this.meetingdetaileditform.patchValue(
            {
              meetingDate: formattedMeetingDate,
              issue: this.data.issue,
              comment: this.data.comment,
              meetingTypeId: this.data.meetingTypeId.toString()
            }

          );


        }
      }));
      this.getAttendantsByMeetingIdAsync(this.id);
    });



    this.subscriptions.push(this.institutionsService.getInstitutions().subscribe(data => {
      // this.data = data;
      data.forEach(element => {

        const inst = { id: element.id, shortName: element.shortName, name: element.name };
        this.institutions.push(inst);

      });
      this.filteredOptions = this.myControl.valueChanges
        .pipe(
          startWith<string | LodgeAndCamp>(''),
          map(value => typeof value === 'string' ? value : value.name),
          map(name => name ? this._filter(name) : this.institutions.slice())
        );
      /* end autocomplete */
    }));

    await this.permissionsService.selectedrole.subscribe(r => {
      this.role = r;
      this.setPermissions(this.institutionid);
    });
  }

  setPermissions(institutionid: number) {
    if (institutionid) {
      let can_edit_member_baseinfo_observable = this.permissionsService.hasPermissionForInstitution('EDIT_ATTENDANCE', institutionid);
      this.subscriptions.push(forkJoin([
        can_edit_member_baseinfo_observable,
      ]).subscribe(response => {
        this.can_edit_attendance = response[0];
      }));
    }
  }

  /* start autocomplete */
  private _filter(name: string): LodgeAndCamp[] {
    const filterValue = name.toLowerCase();
    // tslint:disable-next-line:max-line-length
    return this.institutions.filter(option => option.name.toLowerCase().indexOf(filterValue) !== -1 || option.shortName.toLowerCase().indexOf(filterValue) !== -1);
  }

  displayFn(user?: LodgeAndCamp): string | undefined {
    return user ? user.shortName + ' ' + user.name : undefined;
  }

  search(event: AutoCompleteCompleteEvent) {
      const query = event.query.toLowerCase();
      this.filteredInstitutions = this.institutions.filter(x => x.name.toLowerCase().includes(query) ||
    x.shortName.toLowerCase().includes(query));
    }
    
    onInstitutionSelected(evt) {
    this.selectedinstitution = evt.value.id;
    this.selectedinstitutionname = evt.value.shortName + ' ' + evt.value.name;
    this.getPossibleAttendants(this.selectedinstitution);  
    }
  onSelectionChanged(event: MatAutocompleteSelectedEvent) {
    this.selectedinstitution = event.option.value.id;
    this.selectedinstitutionname = event.option.value.shortName + ' ' + event.option.value.name;
    this.getPossibleAttendants(this.selectedinstitution);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }

  getAttendantsByMeetingIdAsync(meetingid: number) {
    this.subscriptions.push(this.meetingService.getAttendantsByMeetingIdAsync(meetingid).subscribe(attendants => {
      this.attendants = [];
      this.guestattendants = [];
      if (attendants) {
        attendants.forEach(att => {
          if (att.isGuest) {
            this.guestattendants.push(att);
          } else {
            this.attendants.push(att);
          }
        });
      }
    }));
  }

  addAttendantToList(id: number, element) {
    if (element.checked) {
      this.addattendancelist.push(id);
    } else {
      this.removeAttendantFromList(id);
    }
  }

  addToDeleteList(id: number, attendanceid: number, element) {
    if (element.checked) {
      const m: DeleteAttendant = {
        memberId: id,
        attendanceId: attendanceid
      };
      this.deletelist.push(m);
    } else {
      this.removeAttendantFromDeleteList(id);
    }
  }

  markAllAttendants(element) {
    this.attendants.forEach(att => {
      att.checked = element.checked;
      if (element.checked) {
        this.addToDeleteList(att.memberId, att.attendanceId, element);
      } else {
        this.removeAttendantFromDeleteList(att.memberId);
      }
    });
  }

  deleteAttendants() {
    this.deletedata = [];
    for (const attendant of this.deletelist) {
      this.attendancedata = {
        attendanceId: attendant.attendanceId,
        action: 'delete'
      };
      this.deletedata.push(this.attendancedata);
    }

    this.meetingService.AddMeetingAttendance(this.deletedata).subscribe(response => {
      if (response) {
        if (response.rowsAffected !== 0) {
          this.getAttendantsByMeetingIdAsync(this.id);
          this.memberService.timestamp.next(+new Date());
          this.snackBarService.openSnackBar('Medlem/medlemmar borttagna som deltagare på mötet.', null);
        }
      }
    });
  }

  removeAttendantFromDeleteList(id: number) {
    const idx = this.deletelist.findIndex(item => item.memberId === id);
    this.deletelist.splice(idx, 1);
  }

  removeAttendantFromList(id: number) {
    this.addattendancelist = this.addattendancelist.filter(item => item !== id);
  }

  // Lägg till ny ordinarie medlem/gäster som närvarande på aktuellt möte.
  addAttendant(attendanttype: string) {
    switch (attendanttype) {
      case 'ordinary': {
        this.addattendancelist = [];
        this.add = true;
        this.addguest = false;
        this.getPossibleAttendants(this.institutionid);
        this.selectedinstitution = null;
        break;
      }
      case 'guest': {
        this.add = false;
        this.addguest = true;
        this.addattendancelist = [];
        this.clear();
        this.selectedinstitution = null;
        break;
      }
    }
    this.memberService.timestamp.next(+new Date());
  }

  getMeetingData(action) {
    return {
      meetingId: this.id,
      institutionId: this.institutionid,
      meetingTypeId: Number(this.meetingdetaileditform.get('meetingTypeId').value),
      meetingDate: this.meetingdetaileditform.get('meetingDate').value,
      issue: this.meetingdetaileditform.get('issue').value,
      comment: this.meetingdetaileditform.get('comment').value,
      action: action
    };
  }
  save() {
    const savedata = this.getMeetingData('update');
    this.meetingService.addMeeting(savedata).subscribe(response => {
      if (response.status === 'ok') {
        this.snackbarService.openSnackBar('Mötet uppdaterat.', null);
      }
    });
    this.disableForm(true);
    this.edit = false;
  }

  saveAttendants() {
    this.addlist = [];
    let institution;
    this.selectedinstitution ? institution = this.selectedinstitution : institution = this.institutionid;
    for (const attendant of this.addattendancelist) {
      this.attendancedata = {
        meetingId: this.id,
        memberId: attendant,
        isGuest: this.addguest,
        institutionId: institution,
        action: 'add'
      };
      this.add = false;
      this.addlist.push(this.attendancedata);
    }
    this.meetingService.AddMeetingAttendance(this.addlist).subscribe(response => {
      if (response) {
        this.attendantstoadd = null;
        this.getAttendantsByMeetingIdAsync(this.id);
        this.add = false;
        this.addguest = false;
        this.memberService.timestamp.next(+new Date());
        this.snackBarService.openSnackBar('Medlem tillagd som deltagare på mötet.', null);
      }
    });
  }

  cancelMeetingDetails() {
    this.location.back();
  }

  cancelAddingAttendants() {
    this.add = false;
    this.addguest = false;
  }

  sortData(sort: Sort) {
    const data = this.attendants.slice();
    if (!sort.active || sort.direction === '') {
      this.attendants = data;
      return;
    }
    this.attendants = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'id': return this.compare(a.memberId, b.memberId, isAsc);
        case 'givenName': return this.compare(a.givenName, b.givenName, isAsc);
        case 'familyName': return this.compare(a.familyName, b.familyName, isAsc);
        case 'primaryInstitution': return this.compare(a.primaryInstitution.shortName, b.primaryInstitution.shortName, isAsc);
        default: return 0;
      }
    });
  }

  sortAddData(sort: Sort) {
    const data = this.attendantstoadd.slice();
    if (!sort.active || sort.direction === '') {
      this.attendantstoadd = data;
      return;
    }
    this.attendantstoadd = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'id': return this.compare(a.id, b.id, isAsc);
        case 'givenName': return this.compare(a.givenName, b.givenName, isAsc);
        case 'familyName': return this.compare(a.familyName, b.familyName, isAsc);
        case 'priminst': return SortService.cmpStringsWithNumbers(a.institutionShortName, b.institutionShortName, isAsc);
        default: return 0;
      }
    });
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  cancel() {
    if (this.meetingdetaileditform.dirty) {
      this.confirmCancelDialog();
    } else {
      this.edit = false;
      this.disableForm(true);
    }
  }

  confirmCancelDialog(): void {
     this.confirmationService.confirm({
      header: 'Bekräftelse',
      message: 'Vill du avbryta utan att spara ändringarna?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
          this.edit = false;
        this.meetingdetaileditform.reset();
        this.ngOnInit();
      },
      reject: () => {
      }
    });
  }

  confirmDeleteDialog(): void {
      this.confirmationService.confirm({
      header: 'Bekräftelse',
      message: 'Vill du säker på att du vill radera aktuellt möte?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
         this.deleteMeeting();
      },
      reject: () => {
      }
    });
  }

  reloadView() {
    // tslint:disable-next-line:max-line-length
    this.router.navigate(['/meetings/meetings/meetingdetails'], { queryParams: { memberid: this.memberid, id: this.id, institutionid: this.institutionid } });
  }

  getPossibleAttendants(institutionid: number) {
    this.meetingService.getPossibleMeetingAttenders(this.id, institutionid).subscribe(data => {
      this.attendantstoadd = data;
    });
  }

  clear() {
    this.myControl.setValue(null);
  }

  deleteMeeting() {
    const removedata = this.getMeetingData('delete');
    this.meetingService.addMeeting(removedata).subscribe(response => {
      if (response.status === 'ok') {
        this.snackbarService.openSnackBar('Mötet raderat', null);
      }
    });
  }

  get meetingTypeId() {
    return this.meetingdetaileditform.get('meetingTypeId');
  }
}
